import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ShowForPermission from '../../../../components/ShowForPermission';
import { deleteReservationTimingByDay } from '../../../../redux/reservationTiming/actions';
import AlertAndConfirmation from '../../../../utils/AlertAndConfirmation';
import ENUMS from '../../../../enums';

const DeleteDaysModal = ({ record }) => {
  const [displayModal, setDisplayModal] = useState(false);

  const dispatch = useDispatch();

  const onDeleteDay = id => {
    dispatch(deleteReservationTimingByDay(id))
      .then(() => {
        const alert = {
          title: locales('titles.deleteReserveDay'),
          text: locales('titles.successfully'),
          type: 'success',
        };
        AlertAndConfirmation(alert);
      });
    handleModal();
  };

  const handleModal = () => setDisplayModal(!displayModal);

  return (
    <>
    <ShowForPermission permission={ENUMS.PERMISSIONS.values.DELETE_CAFE_SCHEDULE}>
      <div className='col-6'>
        <i className="text-center fal fa-trash text-danger pointer"
          title={locales('titles.deleteReserveDay')}
          onClick={handleModal} />
      </div>

      <Modal size='lg' isOpen={displayModal}>
        <ModalHeader>
          {locales('titles.deleteReserveDay')}
        </ModalHeader>

        <ModalBody>
          <div className="col-12 p-0">
            <div className="col-12 p-0">{locales('titles.sureToDeleteReservationDay')} ؟</div>
          </div>
        </ModalBody>

        <ModalFooter>
          <button type="button" className="btn btn-success mx-1" onClick={() => onDeleteDay(record.id)}>
            {locales('labels.yes')}
          </button>
          <button type="button" className="btn btn-danger mx-1" onClick={handleModal}>
            {locales('labels.no')}
          </button>
        </ModalFooter>
      </Modal>
      </ShowForPermission>
    </>
  );
}

export default DeleteDaysModal;